import * as zod from 'zod';
import { defaultAp01ToAp15Values } from '../../../Constants/Consts';
import { DDCheckList } from '../../../types/DataDD/DataDD';
import { buildBasePayload } from '../buildBasePayload';
import type { FormVariant } from '../types';

const RAD_MODEL_NUMBER_OPTIONS = ['Tag', 'Device', 'Unit Tag', 'Unit Device'] as const;

const RAD_MODEL_NUMBER_DROPDOWN_OPTIONS = RAD_MODEL_NUMBER_OPTIONS.map((o) => ({
    text: o,
    value: o,
}));

const radSchema = zod.object({
    dd02: zod.string().trim().min(1, { message: 'Please enter the location.' }),
    dd03: zod.string().trim().min(1, { message: 'Please enter the tag/device.' }),
    ap01: zod.string().trim().min(1, { message: 'Please enter the tag/device description.' }),
    dd04: zod.string().trim().min(1, { message: 'Please enter the PLC address.' }),
    modelNumber: zod.enum(RAD_MODEL_NUMBER_OPTIONS, {
        errorMap: () => ({ message: 'Please select a model number.' }),
    }),
});

export const radVariant: FormVariant<typeof radSchema> = {
    schema: radSchema,
    fields: [
        { key: 'dd02', label: 'Location', placeholder: 'Location', kind: 'text' },
        { key: 'dd03', label: 'Tag/Device', placeholder: 'Tag/Device', kind: 'text' },
        { key: 'ap01', label: 'Tag/Device Description', placeholder: 'Tag/Device Description', kind: 'text' },
        { key: 'dd04', label: 'PLC Address', placeholder: 'PLC Address', kind: 'text' },
        {
            key: 'modelNumber',
            label: 'Model Number',
            placeholder: 'Model Number',
            kind: 'select',
            options: RAD_MODEL_NUMBER_DROPDOWN_OPTIONS,
        },
    ],
    defaultValues: { dd02: '', dd03: '', ap01: '', dd04: '', modelNumber: '' as typeof RAD_MODEL_NUMBER_OPTIONS[number] },
    getPayload: (data, firstTask, uuid): DDCheckList => ({
        ...buildBasePayload(firstTask, uuid),
        dd02: data.dd02,
        dd03: data.dd03,
        dd04: data.dd04,
        dd05: '',
        modelNumber: data.modelNumber,
        modelDescription: firstTask.modelDescription,
        taskDescription: `${data.dd02} - ${data.dd03} - ${data.ap01} - ${data.dd04}`,
        // taskDescription:"Pre-commissioned",
        taskHeader: 'AD HOC',
        ...defaultAp01ToAp15Values,
        ap01: data.ap01,
    } as DDCheckList),
};
